import Form from 'antd/es/form';
import type { FormInstance } from 'antd/es/form';
import Input from 'antd/es/input';
import Typography from 'antd/es/typography';
import React from 'react';
import { styled } from 'styled-components';

const { Text } = Typography;
const { TextArea } = Input;

const FormSection = styled.div`
  margin-bottom: ${({ theme }) => theme.marginLG}px;
`;

const SectionDescription = styled(Text)`
  display: block;
  margin-bottom: ${({ theme }) => theme.marginMD}px;
  color: ${({ theme }) => theme.colorTextSecondary};
`;

interface PipelineBasicsFormProps {
  form: FormInstance;
}

export const PipelineBasicsForm: React.FC<PipelineBasicsFormProps> = ({
  form: _form,
}) => {
  return (
    <FormSection>
      <SectionDescription>
        Give your pipeline a descriptive name and optional description to help
        team members understand its purpose.
      </SectionDescription>

      <Form.Item
        name="name"
        label="Pipeline Name"
        rules={[
          { required: true, message: 'Please enter a pipeline name' },
          { min: 1, message: 'Pipeline name cannot be empty' },
          { max: 255, message: 'Pipeline name cannot exceed 255 characters' },
          {
            pattern: /^[^\s].*[^\s]$/,
            message: 'Pipeline name cannot start or end with whitespace',
          },
        ]}
      >
        <Input
          placeholder="e.g., Document Analysis Pipeline, Daily Report Generator"
          autoFocus
        />
      </Form.Item>

      <Form.Item
        name="description"
        label="Description (Optional)"
        rules={[
          { max: 1000, message: 'Description cannot exceed 1000 characters' },
        ]}
      >
        <TextArea
          rows={4}
          placeholder="Describe what this pipeline does, its inputs and outputs, and when it should be used..."
          showCount
          maxLength={1000}
        />
      </Form.Item>
    </FormSection>
  );
};
